import { map } from 'rxjs';

import { AsyncPipe, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe, DomainDataFacade, ResourcesService } from '@mitsubishi/core';
import { EnergyAnalysis } from '@mitsubishi/project/data-access';
import { ApmFaIconComponent, IconComponent, MomentDatePipe } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-energy-analyses-card',
  templateUrl: './energy-analyses-card.component.html',
  imports: [AsyncPipe, NgStyle, MatTooltip, ApmTranslatePipe, MomentDatePipe, IconComponent, ApmFaIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnergyAnalysesCardComponent {
  readonly energyAnalyses = input.required<EnergyAnalysis>();
  /**
   * Codice e nome del progetto, come sulla card delle selezioni: servono nella lista globale, dove le
   * analisi arrivano da progetti diversi. Dentro il progetto sarebbero una ripetizione.
   */
  readonly showProject = input(false);

  readonly commonDataFacade = inject(DomainDataFacade);
  readonly #resourcesService = inject(ResourcesService);

  readonly systemsCount = computed(() => this.energyAnalyses().systemsCount || 0);
  readonly cardClick = output<MouseEvent>();

  readonly cityLabel = computed(() => {
    const city = this.energyAnalyses().city;
    return city ? this.translateWithFallback(city.id, city.name) : '';
  });

  readonly countryLabel = computed(() => {
    const country = this.energyAnalyses().city?.country;
    return country ? this.translateWithFallback(country.id, country.name) : '';
  });

  readonly matchingSegment$ = this.commonDataFacade.segments$.pipe(
    map(segments => segments?.find(segment => segment.id === this.energyAnalyses().segmentId))
  );

  onCardClick($event: MouseEvent) {
    this.cardClick.emit($event);
  }

  private translateWithFallback(key: string | number, fallbackName?: string): string {
    const numKey = Number(key);
    if (isNaN(numKey)) {
      return fallbackName ?? key.toString();
    }
    if (fallbackName !== undefined && !this.#resourcesService.getResource(numKey)) {
      return fallbackName;
    }
    return this.#resourcesService.getTextResource(key);
  }
}
